import React, { createContext, useContext, useState, useEffect } from "react";

const CommentDataContext = createContext();

export const useCommentData = () => useContext(CommentDataContext);

export const CommentDataProvider = ({ children }) => {
  // username from canvas engine
  const [username, setUserName] = useState(null);
  //active cell
  const [activeCell , setActiveCell] = useState(null);
  // tabs
  const tabs = ["bug", "improvement", "query"];
  // active tabs
  const [activeTab, setActiveTab] = useState(tabs[0]);
  //edit mode on off
  const [editable, setEditable] = useState(false);
  // draw dot mode
  const [isDotMode, setisDotMode] = useState(false);
  // rectangle mode
  const [rectangleMode, setrectangleMode] = useState(false);
  //selected bug / improvement / query
  const [selectedQuery, setSelectedQuery] = useState(null);
  // searched comments queries
  const [searchedCommentQueries, setSearchedCommentQueries] = useState(null);
  // is seacrh active
  const [searchActive, setSearchActive] = useState(false);
  //see  all bugs / impr / query
  const [seeAllDots, setseeAllDots] = useState(false);
  //all visible Details
  const [allVisibleDetails, setAllVisibleDetails] = useState([]);
  // Global data structure to hold all meta data
  const [commentDetails, setCommentDetails] = useState({
    username: username,
    bug: [],
    improvement: [],
    query: [],
  });
  function updateUsername() {
    // const username = "Candidate_" + Math.floor(Math.random() * 100);
    // localStorage.setItem("candidateId", username);
    const candidateId = localStorage.getItem("candidateId");
    setUserName(candidateId);
    window.canvasEngine.FeatureRenderer.updateUsername(username);
  }

  useEffect(() => {
    updateUsername();
    
    const handleSceneUpdate = (e) => {
      const {
        scene,
        selectedQuery: selected,
        activeTab,
        isDotMode,
        allDetails,
        activeCell,
      } = e.detail;
      setCommentDetails((prev) => {
        return {
          ...prev,
          bug: scene.bug || [],
          improvement: scene.improvement || [],
          query: scene.query || [],
        };
      });
      setAllVisibleDetails(allDetails);
      setSelectedQuery(selected);
      setActiveTab(activeTab);
      setisDotMode(isDotMode);
      setActiveCell(activeCell);
    };
    window.canvasEngine?.FeatureRenderer?.emitSceneUpdate?.();
    window.addEventListener("sceneUpdated", handleSceneUpdate);
    return () => window.removeEventListener("sceneUpdated", handleSceneUpdate);
  }, []);
  return (
    <CommentDataContext.Provider
      value={{
        activeCell,
        setActiveCell,
        commentDetails,
        setCommentDetails,
        isDotMode,
        setisDotMode,
        tabs,
        activeTab,
        setActiveTab,
        setrectangleMode,
        rectangleMode,
        username,
        editable,
        setEditable,
        selectedQuery,
        setSelectedQuery,
        seeAllDots,
        setseeAllDots,
        allVisibleDetails,
        setAllVisibleDetails,
        searchedCommentQueries,
        setSearchedCommentQueries,
        searchActive,
        setSearchActive,
      }}
    >
      {children}
    </CommentDataContext.Provider>
  );
};
